module.exports = __webpack_public_path__ + "static/media/transportation.6c23ea54.jpg";